import React, { useState } from "react";
import { default as Input, IInputProps } from "./Input";

const parseCurrency = (value: string) => {
  if (value === "." || value === ",") {
    value = "0.";
  } else if (value.indexOf(",") > -1) {
    value = value.replace(/,/g, ".");
  }
  return value;
};

export const CurrencyInput: React.FC<IInputProps> = React.memo(props => {
  const { value, onFocus, onBlur } = props;
  const [isInputFocused, setIsInputFocused] = useState(false);

  const formatCurrency = (value: any) => {
    if (value === "" || isNaN(Number(value))) {
      return value;
    }
    if (isInputFocused) {
      return String(value);
    }

    return new Intl.NumberFormat("pl-PL", { style: "currency", currency: "PLN" }).format(
      Number(value)
    );
  };

  return (
    <Input
      {...props}
      value={formatCurrency(value)}
      onFocus={() => {
        setIsInputFocused(true);
        onFocus && onFocus();
      }}
      onBlur={val => {
        setIsInputFocused(false);
        onBlur && onBlur(val);
      }}
      parseValue={parseCurrency}
      allowedSignsRegex={props.allowedSignsRegex || "^[0-9]*[.,]?[0-9]{0,2}$"}
    />
  );
});
